<template>
  <section>
    <!-- <section>
      <q-list bordered separator>
        <q-item
          clickable
          v-ripple
        >
          <q-item-section @click="goToLKTest">
            ECOHOSPITAL
          </q-item-section>
        </q-item>
        <q-item
          clickable
          v-ripple
        >
          <q-item-section @click="goToDevPro">
            DEV Medsafe PRO
          </q-item-section>
        </q-item>
        <q-item
          clickable
          v-ripple
        >
          <q-item-section @click="goToDevDoctor">
            DEV Medsafe DOCTOR
          </q-item-section>
        </q-item>

      </q-list>
    </section> -->
    <section>
      <div class="flex justify-center">
        <q-img
          src="@/assets/medsafe-logo.png"
          width="200px"
          class="q-mt-lg"
        />
      </div>
      <app-selector v-if="apps.length" :apps="apps" />
    </section>
  </section>
</template>

<script lang="ts">
import { storeToRefs } from 'pinia';
import { defineComponent, ref, onMounted } from 'vue';
// eslint-disable-next-line import/no-cycle
import { useAuthStore } from '@/store/auth/authModule';
import { useRouterStore } from '@/store/router/routerModule';
import AppSelector from '@/components/AppSelector.vue';

export default { name: 'AppListView' };
</script>

<script setup lang="ts">
onMounted(async () => {
  console.log('AppListView mounted');
  apps.value = await useRouterStore().getAppList();
});

const apps = ref<any[]>([]);
const store = useAuthStore();
const { getAvailableApps } = storeToRefs(store);

// const goToLKTest = () => {
//   window.open('https://ecohospital.ru/redirect-login', '_blank');
// };
// const goToDevPro = () => {
//   window.open('https://dev.medsafe.pro/redirect-login', '_blank');
// };
// const goToDevDoctor = () => {
//   window.open('https://dev.medsafe.doctor/#/redirect-login', '_blank');
// };
</script>
